import { useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { PageShell } from '@/components/layout/PageShell';
import { useUIStore } from '@/stores/uiStore';

export function App() {
  const { loading } = useAuth();
  const theme = useUIStore((s) => s.theme);

  // Apply theme class on mount
  useEffect(() => {
    document.documentElement.classList.toggle('light', theme === 'light');
    document.documentElement.classList.toggle('dark', theme === 'dark');
  }, [theme]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="text-center space-y-4">
          <div className="h-10 w-10 animate-spin rounded-full border-4 border-primary border-t-transparent mx-auto" />
          <p className="text-muted-foreground text-sm">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  return <PageShell />;
}
